import { defineMessages } from 'react-intl';

export default defineMessages({
    adminTitle: {
        id: 'ri.admin.views.admin-landing.title.Administration',
        defaultMessage: 'Administration'
    },      
    policyProfile: {
        id: 'ri.admin.views.admin-landing.Policy Profile',
        defaultMessage: 'Policy Profile'
    },
    userManager: {
        id: 'ri.admin.views.admin-landing.User Manager',
        defaultMessage: 'User Manager'
    },
    myPolicy: {
        id: 'ri.admin.views.admin-landing.My Policy',
        defaultMessage: 'My Policy'
    },    
    policyNumber: {
        id: 'ri.admin.views.admin-landing.Policy Number',
        defaultMessage: 'Policy Number'
    },
    policyProfileTitle: {
        id: 'ri.admin.views.policyprofile.title.Policy Profile',
        defaultMessage: 'Policy Profile'
    },
    policyProfileTitle: {
        id: 'ri.admin.views.usermanager.title.Policy Users',
        defaultMessage: 'Policy Users'
    },
    noResultFound: {
        id: 'ri.admin.views.admin-landing.No results found for this filter',
        defaultMessage: 'No results were found for this filter.'
    },
    billingDelivery: {
        id: "ri.admin.views.admin-landing.Billing Delivery",
        defaultMessage: "Billing Delivery"
    }
});
